import '../styles/DropMore.css';
import SingleMore from './SingleMore';

// TODO base conditional on "className" prop
// isSidebarShown
export default function DropMore({className}) {
    
    // const conditionalClass = isSidebarShown ? 'container-more' : 'container-more minimized';

    return (
        <section className={`${className}`}>
            {/* TODO map moreItems */}
            {/* TODO for morePath, redirect to components from the Settings menu */}
            {/* <SingleMore moreTitle={'Help'} morePath={'/login'} /> */}
            <SingleMore moreTitle={'About\u00A0DocuQuest'} morePath={'/about'} />
        </section>
    );
}
